import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import BrandPortalToursPage from "../../workspace/kg/brand-portal-tours";
import NewBrandHomepageStatesPage from "../../workspace/kg/new-brand-homepage-states";

const PreactivationHomepageV1Page = lazy(
  () => import("../../workspace/kg/preactivation-homepage-v1/Page")
);
const PreactivationHomepageV2Page = lazy(
  () => import("../../workspace/kg/preactivation-homepage-v2/Page")
);

export const KevinGengRoutes: React.FC = () => (
  <Switch>
    <Route path="/kg/brand-portal-tours" component={BrandPortalToursPage} />
    <Route
      path="/kg/new-brand-homepage-states"
      component={NewBrandHomepageStatesPage}
    />
    <Route
      path="/kg/preactivation-homepage-v1"
      component={PreactivationHomepageV1Page}
    />
    <Route
      path="/kg/preactivation-homepage-v2"
      component={PreactivationHomepageV2Page}
    />
  </Switch>
);

export const slug = "kg";
